import { type Certificate } from './certificate'
import { type TFunction } from 'i18next'

const getRblSignature = (certificate: Certificate, t: TFunction, format: 'month-year' | 'full' = 'full'): string => {
  const year = certificate.camp.end ? (new Date(certificate.camp.end)).getFullYear().toString() : undefined
  const month = certificate.camp.end ? ((new Date(certificate.camp.end)).getMonth() + 1).toString() : undefined

  if (format === 'month-year') {
    return 'Leipzig, ' + (month ? ` ${t(`animation_label.m.${month}`)}` : '') + (year ? ` ${year}` : '')
  }

  if (certificate.camp.end) {
    const date = new Date(certificate.camp.end)
    const day = String(date.getDate()).padStart(2, '0')
    const monthNum = String(date.getMonth() + 1).padStart(2, '0')
    const yearShort = String(date.getFullYear()).slice(-2)
    return `Leipzig, ${day}.${monthNum}.${yearShort}`
  }
  return 'Leipzig'
}

export default getRblSignature
